import React from 'react';
import SuggestionCardBase from '../SuggestionCardBase';
import { StringConstantsMixin } from '../../../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import Button from '../../../../../../components/shared/Button';

const {
  strings: {
    COMMUNITY: {
      CONTACTS,
      FIND_MEMBERS,
      CONNECT: { CONNECT }
    }
  }
} = StringConstantsMixin;

const ContactsSuggestionCard = () => {
  return (
    <SuggestionCardBase
      title={CONTACTS}
      subtext={FIND_MEMBERS}
      imgSrc="https://cdn-assets.alltrails.com/assets/icons/contacts.svg"
      button={
        <Button variant="primary" onClick={() => console.log('TODO: WIRE UP CONTACTS')}>
          {CONNECT}
        </Button>
      }
    />
  );
};

export default ContactsSuggestionCard;
